import React, { useContext, useMemo } from "react";
import { BBVAFinancing } from "./BBVAFinancing/web";
import { ItauFinancing } from "./ItauFinancing/web";
import { ConfigStateContext } from "../../Contexts/Configurations/context";
import { isRent, isSell } from "../../Utils/Functions";
import { MapfreFinancing } from "./MapfreFinancing/web";
import "./styles.less";

const PROPERTY_TYPE_NOT_TO_BE_DISPLAYED = 3;
const MIN_PROPERTY_PRICE = 37000;

const IsPriceToConsult = price =>
	!price?.currency || !price || price.amount == 0 || (price?.isTemp && price?.amount < 5);

export const Financing = ({
	operationType,
	id,
	propertyType,
	propertyPrice,
	isDisabledProperty = false,
	reference = "",
	financingRef = null,
	showFinancingCard = false,
}) => {
	const { country_code } = useContext(ConfigStateContext);

	return (
		<>
			{isSell(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			propertyType &&
			propertyType != PROPERTY_TYPE_NOT_TO_BE_DISPLAYED &&
			propertyPrice.amount >= MIN_PROPERTY_PRICE &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<BBVAFinancing
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
					price={propertyPrice.amount}
				/>
			) : null}
			{isRent(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<MapfreFinancing
					id={id}
					propertyType={propertyType}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			) : null}
			{isSell(operationType) && country_code == "PY" && (
				<ItauFinancing
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			)}
		</>
	);
};
